import type { NumberLinePayload } from '@/components/whiteboard-v2/types';

/**
 * Convert natural-language number-line description into structured payload.
 */
export async function generateNumberLinePayload(
  description: string,
  context?: string,
): Promise<NumberLinePayload> {
  const response = await fetch('/napi/diagram/number-line/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ description, context }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error || `Number-line API returned ${response.status}`);
  }

  const data = (await response.json()) as { payload: NumberLinePayload };
  return data.payload;
}
